"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeFilterError = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
/**
 * AttributeFilter error component that display error,
 * It does not distinguish different errors, instead it renders a generic error message.
 * @beta
 */
exports.AttributeFilterError = function (_props) {
    return (react_1.default.createElement("div", { className: "gd-message error s-button-error" },
        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "gs.filter.error" })));
};
//# sourceMappingURL=AttributeFilterError.js.map